<template>
	<el-form :model="stationSearchForm" ref="stationSearchForm" size="mini" :inline="true" :rules="searchFormRules">
		<el-col :span="3">
			<el-form-item prop="operatorId">
				<!--          <el-select placeholder="运营商" v-model="stationSearchForm.operatorId" clearable>
            <el-option v-for="item in operatorForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
				<el-cascader size="mini" clearable ref="cascader" placeholder="运营商" filterable
					:options="operatorForSelect" :props="{ checkStrictly:true,expandTrigger:'hover'}"
					:show-all-levels="false" change-on-select @change='handleChangeOperator'
					v-model="stationSearchForm.operatorId">
				</el-cascader>
			</el-form-item>
		</el-col>
		<el-col :span="3">
			<el-form-item prop="stationCode">
				<el-input placeholder="充电站编号" v-model="stationSearchForm.stationCode" clearable></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="3">
			<el-form-item prop="stationName">
				<el-input placeholder="充电站名称" v-model="stationSearchForm.stationName" clearable></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="3">
			<el-form-item prop="stationStatus">
				<el-select placeholder="充电站状态" v-model="stationSearchForm.stationStatus" clearable>
					<el-option v-for="item in stationStatusData" :key="item.value" v-bind:label="item.message"
						v-bind:value="item.value"></el-option>
				</el-select>
			</el-form-item>
		</el-col>
		<el-col :span="3">
			<el-form-item prop="stationType">
				<el-select placeholder="充电站类型" v-model="stationSearchForm.stationType" clearable>
					<el-option v-for="item in stationTypeData" :key="item.value" v-bind:label="item.message"
						v-bind:value="item.value"></el-option>
				</el-select>
			</el-form-item>
		</el-col>
		<el-col :span="1.5">
			<el-form-item>
				<el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
			</el-form-item>
		</el-col>
		<el-col :span="1.5">
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="submitStationSearchForm"
					:loading="getStationsLoading">查询
				</el-button>
			</el-form-item>
		</el-col>
	</el-form>
</template>

<script>
	import {
		validateInput
	} from '../../../../common/validator'
	export default {
		name: "search",
		data() {
			return {
				searchFormRules: {
					stationCode: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 16, true, true, true, true, false, false,
								false)
						},
						trigger: 'blur'
					}],
					stationName: [{
						validator: function(rule, value, callback) {
							validateInput(rule, value, callback, 0, 16, true, true, false, false, false, false,
								false)
						},
						trigger: 'blur'
					}],
				}
			}
		},
		props: {
			stationSearchForm: {},
			operatorForSelect: '',
			stationStatusData: '',
			stationTypeData: '',
			getStationsLoading: false,
		},
		methods: {
			resetSearchForm() {
				for (let item in this.stationSearchForm) {
					if (this.stationSearchForm[item]) {
						this.stationSearchForm[item] = ''
					}
				}
				this.submitStationSearchForm()
			},
			handleChangeOperator(value) {
				console.log(value)
				let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
				this.stationSearchForm.operatorId = operatorId
				this.$refs.cascader.dropDownVisible = false
			},
			submitStationSearchForm() {
				this.$emit('submitStationSearchForm')
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/search.vue